module.exports = __webpack_public_path__ + "static/media/es-ct.9429ea9c.svg";